<p-dialog
  [visible]="visible()"
  (onHide)="onCancel()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
  [showHeader]="false"
  styleClass="logout-dialog"
>
  <div class="logout-modal-content">
    <div class="icon-container">
      <img
        [src]="currentConfig()?.theme?.logoutIcon || 'assets/logout-gse.svg'"
        alt="connected"
        style="width: 3.75rem; height: 3.75rem; object-fit: contain"
      />
    </div>

    <h2 class="modal-title">Logout</h2>
    <p class="modal-message">
      Are you sure you want to log out?<br />
      You'll be logged out of this session.
    </p>
  </div>

  <div class="modal-footer">
    <p-button
      label="Cancel"
      [outlined]="true"
      severity="secondary"
      (click)="onCancel()"
      styleClass="cancel-btn"
    ></p-button>
    <p-button
      label="Logout"
      severity="danger"
      (click)="onConfirm()"
      styleClass="confirm-btn"
    ></p-button>
  </div>
</p-dialog>
